// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SEARCH_TERM_MAXIMUM_CHARACTERS } from '@/constants/search-term';
import { z } from 'zod';

/** Cuts a search term to the longest one the backend accepts. */
export function toCappedSearchTerm(term: string): string {
  // The backend counts characters, so a character is never cut in half.
  return Array.from(term).slice(0, SEARCH_TERM_MAXIMUM_CHARACTERS).join('');
}

/** Reads a search term from the URL, cut to the longest one the backend accepts. */
export const searchTermSchema = z
  .string()
  .transform(toCappedSearchTerm)
  .optional();
